import axios from "axios";
import { saveAs } from "file-saver";
import Vue from "vue";
import { Module } from "vuex";
import { RootState } from "@/types";
import { SiteState } from "@/types/site";

/*
 * Interface
 */
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    downloadPDF: async ({ commit }, site_id: number) => {
      try {
        const response = await axios.get(`/admin/site/${site_id}/pdf`, {
          responseType: "blob",
          withCredentials: false
        });
        const blob = new Blob([response.data], { type: response.data.type });
        saveAs(blob, "genbari_report.pdf");
        return true;
      } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
          commit("error/error", error.response.data, { root: true });
        }
        Vue.prototype.$flashStorage.flash("ダウンロード失敗", "error", {
          timeout: 3000,
          important: true
        });
        return false;
      }
    }
  }
} as Module<SiteState, RootState>;
